import { Drawer, Empty, Space, Timeline, Typography } from "antd";
import { useEffect } from "react";
import dayjs from "dayjs";
import { useBuscarAndamentosAssinatura } from "../hooks/useBuscarAndamentosAssinatura";

const { Text } = Typography;

interface ModalAndamentosAssinaturaProps {
  isModalOpen: boolean;
  handleFechar: () => void;
  assinaturaId: number | null;
}

const getTipoIcon = (tipo: string) => {
  switch (tipo) {
    case "MUDANCA":
      return "Alteracao";
    case "CRIACAO":
      return "Criacao";
    case "EXCLUSAO":
      return "Exclusao";
    case "ATUALIZACAO":
      return "Atualizacao";
    default:
      return "Registro";
  }
};

const getTipoColor = (tipo: string) => {
  switch (tipo) {
    case "MUDANCA":
      return "orange";
    case "CRIACAO":
      return "green";
    case "EXCLUSAO":
      return "red";
    default:
      return "gray";
  }
};

const getAutor = (andamento: {
  criadoPor?: {
    tipo?: string;
    nome?: string;
  };
}) => {
  if (!andamento.criadoPor) return null;

  if (andamento.criadoPor.tipo === "SISTEMA") {
    return "Sistema";
  }

  if (andamento.criadoPor.tipo === "USUARIO" && andamento.criadoPor.nome) {
    return andamento.criadoPor.nome;
  }

  return andamento.criadoPor.tipo || null;
};

export default function ModalAndamentosAssinatura({
  isModalOpen,
  handleFechar,
  assinaturaId,
}: ModalAndamentosAssinaturaProps) {
  const { andamentos, loading, buscar } = useBuscarAndamentosAssinatura();

  useEffect(() => {
    if (isModalOpen && assinaturaId) {
      buscar(assinaturaId);
    }
  }, [isModalOpen, assinaturaId, buscar]);

  return (
    <Drawer
      onClose={handleFechar}
      open={isModalOpen}
      title="Andamentos da Assinatura"
      width={600}
      destroyOnClose
    >
      {loading ? (
        <div style={{ textAlign: "center", padding: "40px 20px" }}>
          <Space direction="vertical" style={{ width: "100%", alignItems: "center" }}>
            <Text type="secondary">Carregando andamentos...</Text>
          </Space>
        </div>
      ) : andamentos.length === 0 ? (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            <div>
              <p style={{ marginBottom: "8px", fontWeight: "500" }}>
                Nenhum andamento registrado
              </p>
              <p style={{ fontSize: "12px", color: "#999" }}>
                Os andamentos da assinatura aparecerao aqui.
              </p>
            </div>
          }
          style={{ marginTop: "40px" }}
        />
      ) : (
        <Timeline
          mode="left"
          items={andamentos.map((andamento) => {
            const autor = getAutor(andamento);
            const dataEvento = andamento.criadoPor?.em || andamento.created_at;

            return {
              children: (
                <div style={{ marginBottom: "12px" }}>
                  <div style={{ display: "flex", alignItems: "center", marginBottom: "4px" }}>
                    <Text strong style={{ flex: 1 }}>
                      {andamento.descricao}
                    </Text>
                  </div>
                  <div style={{ marginLeft: "8px" }}>
                    <Text
                      type="secondary"
                      style={{
                        fontSize: "12px",
                        display: "block",
                        marginBottom: "4px",
                      }}
                    >
                      {dayjs(dataEvento).format("DD/MM/YYYY HH:mm")}
                    </Text>
                    <Text
                      style={{
                        display: "block",
                        marginBottom: andamento.observacoes ? "8px" : "4px",
                        fontSize: "12px",
                        color: "#595959",
                      }}
                    >
                      Tipo: {getTipoIcon(andamento.tipo)}
                    </Text>
                    {andamento.observacoes ? (
                      <Text style={{ display: "block", marginBottom: "8px" }}>
                        {andamento.observacoes}
                      </Text>
                    ) : null}
                    {autor ? (
                      <Text
                        style={{
                          fontSize: "12px",
                          color: "#1890ff",
                          fontWeight: "500",
                        }}
                      >
                        Por: {autor}
                      </Text>
                    ) : null}
                  </div>
                </div>
              ),
              color: getTipoColor(andamento.tipo),
            };
          })}
        />
      )}
    </Drawer>
  );
}
